import gql from 'graphql-tag';

export const getCoursesGradeRecord = gql`
  query getCoursesGradeRecord {
    getCoursesGradeRecord {
      name
      items {
        cycle
        courseName
        grade
        approvalStatus
        catalogNumber
        numberTimes
        weeklyHours
        credits
        section
      }
    }
  }
`;
